var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20553 14.6641C5.24841 14.6693 5.29176 14.6693 5.33464 14.6641L7.48656 14.1263C7.58203 14.1036 7.66946 14.0552 7.73941 13.9864L14.3512 7.35519C14.5516 7.15366 14.6641 6.88104 14.6641 6.59688C14.6641 6.31271 14.5516 6.04009 14.3512 5.83856L13.5012 4.98344C13.4012 4.88343 13.2826 4.80409 13.152 4.74996C13.0213 4.69583 12.8813 4.66797 12.7399 4.66797C12.5985 4.66797 12.4585 4.69583 12.3279 4.74996C12.1973 4.80409 12.0786 4.88343 11.9787 4.98344L5.36692 11.5932C5.29741 11.6634 5.24736 11.7505 5.22167 11.8459L4.68369 13.9972C4.66435 14.0668 4.65924 14.1395 4.66864 14.2112C4.67805 14.2828 4.70178 14.3517 4.73844 14.414C4.77509 14.4762 4.8239 14.5304 4.88197 14.5734C4.94004 14.6164 5.00617 14.6472 5.07641 14.6641C5.1193 14.6693 5.16265 14.6693 5.20553 14.6641ZM12.7372 5.74175L13.5926 6.59688L12.7372 7.452L11.8872 6.59688L12.7372 5.74175ZM6.23307 12.2493L11.1233 7.35519L11.9787 8.21032L7.08308 13.1044L5.94794 13.3841L6.23307 12.2493Z",
    fill: "#495057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 4.10981H5.22483V1.33203H4.0026V4.10981H1.33594V5.33203H4.0026V7.9987H5.22483V5.33203H8.0026V4.10981Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPencil);
export default __webpack_public_path__ + "static/media/bx-pencil.c0160b2fb36702b5dd60323637876356.svg";
export { ForwardRef as ReactComponent };